// extracted by mini-css-extract-plugin
export default {"SortIndicator":"SortIndicator_SortIndicator__Xshsb"};